'use client';

import React from 'react';
import { Box, Container, Grid, Stack } from '@mui/material';

import { FooterSkeleton } from '../../skeletons';
import { FooterBottom, FooterBrand, FooterNavSection, FooterSocials } from './subcomponents';

import {
  FOOTER_QUICK_LINKS,
  FOOTER_SUPPORT_LINKS,
  LAYOUT_MAX_WIDTH,
  PLATFORM_SOCIAL_LINKS,
} from '@/constants';

interface FooterProps {
  onHowItWorksOpen?: () => void;
  isLoading?: boolean;
}

const Footer = ({ onHowItWorksOpen, isLoading }: FooterProps) => {
  const handleLinkClick = (name: string) => {
    if (name === 'How it Works' && onHowItWorksOpen) {
      onHowItWorksOpen();
    }
  };

  if (isLoading) {
    return <FooterSkeleton />;
  }

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'background.paper',
        pt: { xs: 8, md: 6 },
        pb: { xs: 10, md: 0 },
        borderTop: '1px solid',
        borderColor: 'divider',
        width: '100%',
        position: 'relative',
        zIndex: 10,
        px: { xs: 2, sm: 4, md: 8 },
      }}
    >
      <Container maxWidth={false} sx={{ maxWidth: LAYOUT_MAX_WIDTH, mx: 'auto' }}>
        <Grid container spacing={{ xs: 6, md: 4 }} justifyContent="space-between">
          {/* Brand & Description Section */}
          <Grid item xs={12} md={4}>
            <FooterBrand />
            <Box sx={{ mt: 4 }}>
              <FooterSocials
                socialLinks={PLATFORM_SOCIAL_LINKS.filter(
                  (link) => link.name !== 'Telegram Contact Us'
                )}
              />
            </Box>
          </Grid>

          {/* Links Section Wrapper */}
          <Grid item xs={12} md={7}>
            <Stack
              direction="row"
              spacing={{ xs: 4, sm: 8, md: 12 }}
              justifyContent={{ xs: 'space-between', md: 'flex-end' }}
              sx={{ height: '100%' }}
            >
              {/* Quick Links Section */}
              <Box>
                <FooterNavSection
                  title="Quick Links"
                  links={FOOTER_QUICK_LINKS}
                  onLinkClick={handleLinkClick}
                  columns={2}
                />
              </Box>

              {/* Support Links Section */}
              <Box>
                <FooterNavSection
                  title="Support"
                  links={FOOTER_SUPPORT_LINKS}
                  onLinkClick={handleLinkClick}
                />
              </Box>
            </Stack>
          </Grid>
        </Grid>

        {/* Bottom Footer Section */}
        <FooterBottom />
      </Container>
    </Box>
  );
};

export default Footer;
